<template>
  <div>
    <small
      class="cursor-pointer text-primary"
      @click="showTransactionDetails = true"
      >Approve</small
    >
    <vs-popup
      title="Redemption Instructions"
      :active.sync="showTransactionDetails"
    >
      <ckeditor
        :editor="editor"
        :config="editorConfig"
        v-model="editorContent"
      ></ckeditor>

      <div class="flex gap-x-2 mt-4">
        <vs-button @click="approveRedemption()" class="w-1/2">
          Approve
        </vs-button>
        <button
          @click="rejectRedemption()"
          class="w-1/2 border-none delete-btn"
        >
          Reject
        </button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-vue2";
export default {
  components: {
    // Use the <ckeditor> component in this view.
    ckeditor: CKEditor.component,
  },
  props: {
    transactionData: {
      type: Object,
      default: () => {},
    },
    orgId: String,
    fetchTransactions: Function,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorContent: "",
      editorConfig: {
        placeholder:
          "Create an email template by writting instructions. Use '@' to call dynamic coupon variables.",
      },
      typingTimerId: null,
      showTransactionDetails: false,
      randomCouponIndex: 0,
    };
  },
  watch: {
    showTransactionDetails: {
      handler: async function (val) {
        if (this.transactionData.product_details !== undefined) {
          const productId = this.transactionData.product_details._id;
          // console.log("productId", productId);
          this.getRedemptionTokensFromProductDetails(productId)
            .then((coupons) => {
              const redemptionInstructions =
                this.transactionData.product_details
                  .product_redemption_instructions;
              const randomCouponCode = coupons[0];
              this.editorContent = this.formatRedemptionInstructions(
                redemptionInstructions,
                randomCouponCode
              );
            })
            .catch((err) => {
              console.log(err);
              this.$vs.notify({
                title: "Error fetching transaction details",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
              });
            });
        }
      },
      deep: true,
    },
  },
  computed: {
    addRedemptionInstructionsPopup() {
      return this.$store.state.modals.addRedemptionInstructionsPopup;
    },
  },
  mounted() {},
  methods: {
    randomIntFromInterval(min, max) {
      // min and max included
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    formatRedemptionInstructions(instructions, couponCode) {
      // Use a regular expression to replace words starting with "@" with "XXXX"
      // console.log(instructions, couponCode);
      var replacedContent = instructions.replace(
        /(@[^<\s]+)(?![^<>]*>)/g,
        couponCode
      );
      // console.log(replacedContent);
      return replacedContent;
    },
    approveRedemption() {
      // console.log("Approve Redemption");
      const accessToken = localStorage.getItem("accessToken");
      const userId = JSON.parse(localStorage.getItem("user"))._id;

      this.$store.dispatch("market/approveRedemptionRequest", {
        userId,
        orgId: this.orgId,
        logId: this.transactionData._id,
        couponIndex: 0,
        redemptionInstructions: this.editorContent,
        accessToken,
      });
      this.showTransactionDetails = false;
      this.fetchTransactions();
    },
    rejectRedemption() {
      // Instead of deleting the log we can also just show if the log is rejected.
      // console.log("Reject Redemption");
      const accessToken = localStorage.getItem("accessToken");
      const userId = JSON.parse(localStorage.getItem("user"))._id;

      this.$store.dispatch("market/rejectRedemptionRequest", {
        userId,
        orgId: this.orgId,
        logId: this.transactionData._id,
        accessToken,
      });
      this.showTransactionDetails = false;
      this.fetchTransactions();
    },
    getRedemptionTokensFromProductDetails(productId) {
      return new Promise((resolve, reject) => {
        const accessToken = localStorage.getItem("accessToken");
        const userId = JSON.parse(localStorage.getItem("user"))._id;
        const orgId = this.orgId;

        const payload = {
          userId,
          orgId,
          productId,
          accessToken,
        };

        this.$store
          .dispatch("market/getProductDetails", payload)
          .then((res) => {
            resolve(res.product.product_coupons);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
</script>

<style scoped>
.delete-btn:hover {
  background-color: #d3d3d3;
  cursor: pointer;
}
.border-none {
  border: none !important;
}
</style>
